import React from 'react';
import CatCard from './CatCard';

const CatList = ({ cats, onDelete }) => {
  return (
    <div className="cat-list-container">
      <h1>My Cats</h1>
      {cats.length === 0 ? (
        <div className="empty-state">
          <p>No cats yet. Start by adding your first cat! 🐱</p>
        </div>
      ) : (
        <div className="cat-grid">
          {cats.map(cat => (
            <CatCard key={cat.id} cat={cat} onDelete={onDelete} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CatList;
